/* eslint-disable linebreak-style */
/* eslint-disable object-curly-spacing */
/* eslint-disable linebreak-style */
import { ExecutionContext, html, ref, repeat } from '@microsoft/fast-element';
import { getCheckBoxValue, MultiSelect } from './';
import { sync } from '@genesislcap/foundation-utils';
import { downIcon } from '../../../styles/icons';

const targetValue = (ctx: ExecutionContext) => (ctx.event.target! as any).value;

export const MultiSelectTemplate = html<MultiSelect>`
  <template @focusout=${(x, c) => x.disableVisibility(c.event as FocusEvent)}>
    <div class="custom-input-search">
      <zero-text-field
        :value=${sync((x) => x.itemSearch)}
        @input="${(x, c) => x.onItemSearch(targetValue(c))};"
        @click=${(x) => x.setItemListVisible(true)}
        @blur=${(x) => x.checkFilteredList()}
        id="item-combo"
        class="input-control"
        type="text"
        ?disabled="${(x) => x.isDisabled}"
        placeholder=${(x) => x.selectedItemsText}
      >
        <zero-button
          @click=${(x) => x.setItemListVisibleButton(!x.isItemListVisible)}
          ?disabled="${(x) => x.disabled}"
        >
          ${downIcon()}
        </zero-button>
      </zero-text-field>
    </div>
    <div style="display: ${(x) => (x.isItemListVisible ? 'inline' : 'none')}">
      <div
        class="fast-listbox"
        id="item-listbox"
        ${ref('listBoxElement')}
        style="position:${(x) => (x.isPositionRelative ? 'relative' : 'absolute')}"
      >
        ${repeat(
          (x) => x.dataSearchList,
          html`
              <zero-checkbox
                ?current-checked=${(x) => x?.CHECKED}
                @click=${(x, c) => c.parent.itemSelected(x.ITEM_ID)}
                value=${(x) => x.ITEM_ID}
                ?disabled=${(x) => x.DISABLED}
                class="fast-checkbox-option"
              >
                ${(x) =>
                  html`
                    ${getCheckBoxValue(x)}
                  `}
              </zero-checkbox>
          `
        )}
      </div>
    </div>
  </template>
`;
